import { render, staticRenderFns } from "./activity-video-upload-modal.vue?vue&type=template&id=526eed50&scoped=true&"
import script from "./activity-video-upload-modal.vue?vue&type=script&lang=js&"
export * from "./activity-video-upload-modal.vue?vue&type=script&lang=js&"
import style0 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=0&id=526eed50&scoped=true&lang=scss&"
import style1 from "./activity-video-upload-modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526eed50",
  null
  
)

component.options.__file = "activity-video-upload-modal.vue"
export default component.exports